import React from 'react';

const Recommendations = () => {
  <h3>Recommendations</h3>;
};

export default Recommendations;
